/**
 * Nature token scoring — §7.4.
 *
 * Each nature token remaining in the player's pool at end of game is worth 1 point.
 * Pure — no I/O, no mutations.
 */

import type { PlayerState } from "../types/player";

/**
 * Returns the player's nature token score: 1 point per token.
 */
export const scoreNatureTokens = (player: PlayerState): number =>
  player.natureTokens;
